// ---------------------------------------------------------------------------
// Team slider — mobile only
// ---------------------------------------------------------------------------
import Splide from '@splidejs/splide';

export function initTeamSlider() {
    const root = document.querySelector('[data-team-slider]');
    if (!root) return;

    const mq = window.matchMedia('(max-width: 765px)');
    let slider = null;
    let resizeTimer = null;

    const cleanupDesktop = () => {
        // На случай, если Splide остался после resize / hot reload.
        root.classList.remove(
            'is-initialized',
            'is-active',
            'is-overflow',
            'is-focus-in',
            'is-loading'
        );

        root.querySelectorAll('.splide__slide--clone').forEach((clone) => {
            clone.remove();
        });

        root.querySelectorAll('.splide__track, .splide__list, .splide__slide').forEach((node) => {
            node.removeAttribute('style');
        });

        root.querySelectorAll('.splide__pagination').forEach((pagination) => {
            pagination.remove();
        });
    };

    const mountSlider = () => {
        if (slider) return;

        cleanupDesktop();

        slider = new Splide(root, {
            type: 'loop',
            perPage: 1,
            perMove: 1,
            gap: 0,
            arrows: false,
            pagination: true,
            autoplay: true,
            interval: 4500,
            speed: 650,
            pauseOnHover: true,
            pauseOnFocus: true,
            drag: true,
            trimSpace: true,
        });

        slider.mount();
    };

    const destroySlider = () => {
        if (slider) {
            slider.destroy(true);
            slider = null;
        }

        cleanupDesktop();
    };

    const updateSlider = () => {
        if (mq.matches) {
            mountSlider();
        } else {
            destroySlider();
        }
    };

    updateSlider();

    if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', updateSlider);
    } else {
        mq.addListener(updateSlider);
    }

    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(() => {
            updateSlider();
        }, 150);
    });
}